module.exports = __webpack_public_path__ + "static/media/PicsolveLab_white.c59b91fb.png";